import { MarketplaceProduct } from 'api/admin/types';
import { Message } from 'features/help/types/messagingCollection';
import { FC } from 'react';
import { DisableConfirmDialog } from './DisableConfirmDialog';
import { EnableAdditionalServicesDialog } from './EnableAdditionalServicesDialog';
import { OtherUnderwritersDisableDialog } from './OtherUnderwritersDisableDialog';
import { OtherUnderwritersEnableDialog } from './OtherUnderwritersEnableDialog';
import { FeatureDetailsDialog } from './types';

export interface FeatureDetailsDialogsProps {
  activeDialog: FeatureDetailsDialog | null;
  selectedService: MarketplaceProduct;
  enabledFraudPreventionProductCodes: string[];
  testIdPrefixDialog: string;
  updateServiceStatus: string;
  isCompletingEnableFlow: boolean;
  isCompletingDisableFlow: boolean;
  acknowledgementMessage?: Message | null;
  onClose: () => void;
  onEnableAcknowledgementAccept: () => void;
  onEnableAdditionalServicesCancelOrClose: () => void;
  onEnableAdditionalServicesContinue: (selectedProductCodes: string[]) => void;
  onOtherUnderwritersDisableConfirm: () => void | Promise<void>;
  onConfirm: () => Promise<void>;
}

export const FeatureDetailsDialogs: FC<FeatureDetailsDialogsProps> = ({
  activeDialog,
  selectedService,
  enabledFraudPreventionProductCodes,
  testIdPrefixDialog,
  updateServiceStatus,
  isCompletingEnableFlow,
  isCompletingDisableFlow,
  acknowledgementMessage,
  onClose,
  onEnableAcknowledgementAccept,
  onEnableAdditionalServicesCancelOrClose,
  onEnableAdditionalServicesContinue,
  onOtherUnderwritersDisableConfirm,
  onConfirm,
}) => {
  if (!activeDialog) {
    return null;
  }

  const baseProps = {
    open: true,
    testIdPrefixDialog,
    updateServiceStatus,
    onClose,
  };

  switch (activeDialog) {
    case FeatureDetailsDialog.OtherUnderwritersEnable:
      return (
        <OtherUnderwritersEnableDialog
          open
          updateServiceStatus={updateServiceStatus}
          acknowledgementMessage={acknowledgementMessage}
          onClose={onClose}
          onAccept={onEnableAcknowledgementAccept}
        />
      );
    case FeatureDetailsDialog.EnableAdditionalServices:
      return (
        <EnableAdditionalServicesDialog
          open
          currentProductCode={selectedService.productCode}
          currentProductName={selectedService.productName}
          currentProductDescription={selectedService.description}
          enabledProductCodes={enabledFraudPreventionProductCodes}
          isSubmitting={updateServiceStatus === 'pending' || isCompletingEnableFlow}
          onClose={onEnableAdditionalServicesCancelOrClose}
          onCancel={onEnableAdditionalServicesCancelOrClose}
          onContinue={onEnableAdditionalServicesContinue}
        />
      );
    case FeatureDetailsDialog.OtherUnderwritersDisable:
      return (
        <OtherUnderwritersDisableDialog
          open
          productName={selectedService.productName}
          isSubmitting={updateServiceStatus === 'pending' || isCompletingDisableFlow}
          onClose={onClose}
          onConfirm={onOtherUnderwritersDisableConfirm}
        />
      );
    case FeatureDetailsDialog.DisableConfirm:
      return <DisableConfirmDialog {...baseProps} onConfirm={onConfirm} />;
    default:
      return null;
  }
};
